export default __webpack_public_path__ + "assets/b88b89a9c92f0e82a47917c70e118486.png";